import ADMIRAL_QUESTION_ID_TO_AUTOFILL_TYPE from '../../Data/Maps/admiralQuestionIdToAutofillType';

export const getHtmlInputTypeFromMap = (fieldType, typeMap) => {
  if (!fieldType) {
    return undefined;
  }

  let mappedInputType;
  Object.entries(typeMap).forEach((entry) => {
    const [inputType, mappedFieldTypes] = entry;
    if (mappedFieldTypes.includes(fieldType)) {
      mappedInputType = inputType;
    }
  });

  return mappedInputType;
};

export const getHtmlInputType = (type, isIos = false, isMasked = false) => {
  if (isMasked && type === 'number') {
    // we can't use number type when masking
    return 'tel';
  }

  const defaultTypeMap = {
    tel: ['tel-us', 'us-zip', 'tel', 'currency'],
    email: ['email'],
    url: ['url'],
    number: ['number'],
  };

  const iosTypeMap = {
    tel: ['tel-us', 'us-zip', 'tel'],
    email: ['email'],
    url: ['url'],
    number: ['number', 'currency'],
  };

  const typeMap = isIos ? iosTypeMap : defaultTypeMap;

  return getHtmlInputTypeFromMap(type, typeMap) || 'text';
};

export const getAutoCompleteName = (autoCompleteType, mappedQuestionId) => {
  if (autoCompleteType === 'disabled') {
    return 'off';
  }
  if (
    Object.keys(ADMIRAL_QUESTION_ID_TO_AUTOFILL_TYPE).includes(mappedQuestionId)
  ) {
    return ADMIRAL_QUESTION_ID_TO_AUTOFILL_TYPE[mappedQuestionId];
  }
  return '';
};
